import fetchApi from "../fetchApi";
import { DEFAULT_LIMIT } from "../../contstants";

export const GetRoles = async (
  perPage = DEFAULT_LIMIT,
  offset = 0,
  name = "",
  isActive = "",
  orderBy = "",
  desc = ""
) => {
  const page = Math.floor(offset / perPage) + 1;

  const params = new URLSearchParams();
  params.append("page", page);
  params.append("per_page", perPage);
  if (name) params.append("name", name);
  if (isActive !== "") params.append("is_active", isActive);
  if (orderBy) params.append("order_by", orderBy);
  if (desc !== "") params.append("desc", desc);

  const options = {
    method: "GET",
    headers: new Headers({
      "Content-Type": "application/json",
    }),
    redirect: "follow",
  };

  return await fetchApi(`roles?${params.toString()}`, options);
};
